export const translations = {
    sk: {
        nav: {
            work: "Portfólio",
            services: "Služby",
            process: "Proces",
            contact: "Kontakt",
            blog: "Blog",
            cta: "Nezáväzný dopyt",
        },
        hero: {
            overline: "Webryno Studio · Webový dizajn · Slovensko",
            badge: "Prijímame nové projekty",
            lines: ["Web, ktorý vám", "prinesie", "klientelu."],
            accentLine: 2,
            sub: "Sme štúdio webového dizajnu zo Slovenska. Navrhujeme a staviame weby na mieru — od prvého návrhu až po spustenie. Bez šablón a bez cenníka: cena je vždy na vyžiadanie.",
            ctaPrimary: "Nezáväzný dopyt",
            ctaSecondary: "Pozrieť portfólio",
            stats: [
                { value: "100%", label: "dizajn na mieru" },
                { value: "24h", label: "odozva na dopyt" },
            ],
        },
        marquee: ["Webový dizajn", "Na mieru", "Redesign", "SEO", "Dlhodobá podpora"],
        portfolio: {
            overline: "Portfólio",
            title: "Vybraná práca",
            sub: "Živé projekty aj autorské návrhy. Každý web staviame na mieru — pre značku, jej zákazníkov a jej ciele.",
            visit: "Navštíviť web",
            liveBadge: "Živý web",
            conceptBadge: "Návrh",
        },
        services: {
            overline: "Služby",
            title: "Všetko, čo váš web potrebuje",
            sub: "Od prvého návrhu po dlhodobú podporu — kompletný servis pod jednou strechou.",
            items: [
                {
                    icon: "layout",
                    title: "Webový dizajn & architektúra",
                    text: "Autorské weby na mieru — od wireframu po finálny pixel. Žiadne šablóny, žiadne kompromisy.",
                },
                {
                    icon: "refresh",
                    title: "Kompletný redesign",
                    text: "Váš web zastarel? Premeníme ho na moderný nástroj, ktorý získava zákazníkov.",
                },
                {
                    icon: "gauge",
                    title: "SEO & rýchlosť",
                    text: "Optimalizácia pre vyhľadávače aj ľudí. Bleskové načítanie na každom zariadení.",
                },
                {
                    icon: "shield",
                    title: "Správa & podpora",
                    text: "O váš web sa staráme aj po spustení — aktualizácie, bezpečnosť a ďalší rozvoj.",
                },
            ],
        },
        price: {
            overline: "Cenová filozofia",
            title: "Cena na vyžiadanie",
            text: "Neuvádzame cenník, pretože žiadne dva projekty nie sú rovnaké. Cenu skladáme podľa rozsahu, funkcií a ambícií vášho projektu — férovo a transparentne, ešte predtým, než sa napíše prvý riadok kódu.",
            points: ["Nezáväzná konzultácia zdarma", "Cenová ponuka do 48 hodín", "Žiadne skryté poplatky"],
            cta: "Vyžiadať cenovú ponuku",
        },
        process: {
            overline: "Proces",
            title: "Ako pracujeme",
            steps: [
                {
                    num: "01",
                    title: "Objavenie & stratégia",
                    text: "Spoznáme vašu značku, ciele aj zákazníkov. Návrh staviame na faktoch, nie na dojmoch.",
                },
                {
                    num: "02",
                    title: "UX/UI návrh",
                    text: "Navrhneme unikátny vizuál a klikateľný prototyp, ktorý si prejdete ešte pred vývojom.",
                },
                {
                    num: "03",
                    title: "Vývoj & optimalizácia",
                    text: "Čistý kód, blesková rýchlosť a dokonalé zobrazenie na mobile aj desktope.",
                },
                {
                    num: "04",
                    title: "Spustenie & podpora",
                    text: "Nasadíme, otestujeme a ostaneme pri vás aj po spustení.",
                },
            ],
        },
        contact: {
            overline: "Kontakt",
            title: "Poďme sa porozprávať o vašom projekte",
            sub: "Napíšte nám o vašom projekte. Ozveme sa do 24 hodín s nezáväzným návrhom riešenia.",
            name: "Vaše meno",
            email: "E-mail",
            phone: "Telefón (nepovinné)",
            message: "Popíšte nám váš projekt…",
            submit: "Odoslať dopyt",
            sending: "Odosielam…",
            success: "Správa odoslaná! Ozveme sa do 24 hodín.",
            error: "Odoslanie zlyhalo. Skúste to prosím znova.",
            emailLabel: "E-mail",
            phoneLabel: "Telefón",
            locationLabel: "Slovensko",
        },
        testimonials: {
            overline: "Referencie",
            title: "Čo hovoria klienti",
            items: [
                {
                    quote: "Web beží bleskovo a dopyty od zákazníkov výrazne pribudli. Spolupráca bola jednoduchá od prvého návrhu po spustenie.",
                    author: "Auto Global Group",
                    role: "Autobazár · Bratislava",
                },
                {
                    quote: "Návrh presne vystihol atmosféru nášho dineru. Retro štýl, ktorý na webe funguje moderne a rýchlo.",
                    author: "Elephant DINER",
                    role: "Reštaurácia · Rača",
                },
                {
                    quote: "Viacjazyčný web dodaný bez komplikácií. Kandidáti aj klienti sa zorientujú okamžite.",
                    author: "Lunulus",
                    role: "Personálna agentúra",
                },
            ],
        },
        faq: {
            overline: "FAQ",
            title: "Časté otázky",
            items: [
                {
                    q: "Koľko stojí webová stránka?",
                    a: "Cena je vždy na vyžiadanie. Každý projekt je iný — cenovú ponuku pripravíme do 48 hodín podľa rozsahu, funkcií a ambícií. Úvodná konzultácia je bezplatná a nezáväzná.",
                },
                {
                    q: "Ako dlho trvá vývoj webu?",
                    a: "Jednoduchý web zvyčajne 2–3 týždne, rozsiahlejšie projekty 4–8 týždňov. Presný harmonogram dostanete spolu s cenovou ponukou.",
                },
                {
                    q: "Musím si niečo pripraviť vopred?",
                    a: "Nie. Stačí predstava o vašom biznise — štruktúru, texty aj dizajn pripravíme spoločne počas úvodnej konzultácie.",
                },
                {
                    q: "Viete upraviť môj súčasný web?",
                    a: "Áno. Robíme kompletné redizajny aj menšie úpravy — od vizuálu cez rýchlosť až po obsah.",
                },
                {
                    q: "Staráte sa o web aj po spustení?",
                    a: "Áno. Ponúkame správu, aktualizácie a technickú podporu, aby váš web bežal spoľahlivo dlhodobo.",
                },
                {
                    q: "V akých jazykoch viete web pripraviť?",
                    a: "Slovensky, anglicky aj viacjazyčne — presne podľa toho, kde pôsobia vaši zákazníci.",
                },
            ],
        },
        footer: {
            tagline: "Weby na mieru zo Slovenska.",
            rights: "Webryno Studio. Všetky práva vyhradené.",
        },
        blog: {
            overline: "Blog",
            title: "Z praxe Webryno Studio",
            sub: "Praktické postrehy o webovom dizajne, cenách a tom, ako z webu dostať skutočných klientov.",
            metaTitleList: "Blog — Webryno Studio",
            metaDescription: "Praktické články o webovom dizajne od Webryno Studio: ceny webov, šablóny vs. dizajn na mieru a ako z webu dostať dopyty.",
            readMore: "Čítať článok",
            allArticles: "Všetky články",
            back: "Späť na blog",
            minRead: "min čítania",
            ctaTitle: "Chcete web, ktorý prináša klientov?",
            ctaText: "Úvodná konzultácia je bezplatná a nezáväzná. Cenovú ponuku pripravíme do 48 hodín.",
            ctaButton: "Nezáväzný dopyt",
        },
    },
    en: {
        nav: {
            work: "Work",
            services: "Services",
            process: "Process",
            contact: "Contact",
            blog: "Blog",
            cta: "Request a quote",
        },
        hero: {
            overline: "Webryno Studio · Web Design · Slovakia",
            badge: "Now accepting new projects",
            lines: ["A website that", "brings you", "clients."],
            accentLine: 2,
            sub: "A web design studio from Slovakia. We design and build bespoke websites — from the first sketch to launch. No templates, no price list: every quote is on request.",
            ctaPrimary: "Request a quote",
            ctaSecondary: "Explore our work",
            stats: [
                { value: "100%", label: "bespoke design" },
                { value: "24h", label: "response time" },
            ],
        },
        marquee: ["Web Design", "Bespoke", "Redesign", "SEO", "Long-term Care"],
        portfolio: {
            overline: "Portfolio",
            title: "Selected work",
            sub: "Live projects and original concepts. Every website is built to measure — for the brand, its customers and its goals.",
            visit: "Visit site",
            liveBadge: "Live site",
            conceptBadge: "Concept",
        },
        services: {
            overline: "Services",
            title: "Everything your website needs",
            sub: "From the first sketch to long-term support — a complete service under one roof.",
            items: [
                {
                    icon: "layout",
                    title: "Web design & architecture",
                    text: "Bespoke websites — from wireframe to final pixel. No templates, no compromises.",
                },
                {
                    icon: "refresh",
                    title: "Complete redesign",
                    text: "Website feeling dated? We turn it into a modern tool that wins customers.",
                },
                {
                    icon: "gauge",
                    title: "SEO & speed",
                    text: "Optimised for search engines and humans alike. Lightning-fast on every device.",
                },
                {
                    icon: "shield",
                    title: "Care & support",
                    text: "We look after your site long after launch — updates, security and growth.",
                },
            ],
        },
        price: {
            overline: "Pricing philosophy",
            title: "Price on request",
            text: "We don't publish a price list because no two projects are alike. Every quote is built around the scope, features and ambition of your project — fairly and transparently, before a single line of code is written.",
            points: ["Free, no-obligation consultation", "Quote within 48 hours", "No hidden fees"],
            cta: "Request a quote",
        },
        process: {
            overline: "Process",
            title: "How we work",
            steps: [
                {
                    num: "01",
                    title: "Discovery & strategy",
                    text: "We learn your brand, goals and customers. Our design stands on facts, not hunches.",
                },
                {
                    num: "02",
                    title: "UX/UI design",
                    text: "A unique visual and clickable prototype you can walk through before development.",
                },
                {
                    num: "03",
                    title: "Build & optimisation",
                    text: "Clean code, fast loading and flawless rendering on mobile and desktop.",
                },
                {
                    num: "04",
                    title: "Launch & support",
                    text: "We deploy, test and stay by your side long after launch.",
                },
            ],
        },
        contact: {
            overline: "Contact",
            title: "Let's talk about your project",
            sub: "Tell us about your project. We'll get back to you within 24 hours with a no-obligation proposal.",
            name: "Your name",
            email: "E-mail",
            phone: "Phone (optional)",
            message: "Tell us about your project…",
            submit: "Send request",
            sending: "Sending…",
            success: "Message sent! We'll reply within 24 hours.",
            error: "Sending failed. Please try again.",
            emailLabel: "E-mail",
            phoneLabel: "Phone",
            locationLabel: "Slovakia",
        },
        testimonials: {
            overline: "Testimonials",
            title: "What clients say",
            items: [
                {
                    quote: "The site runs lightning-fast and customer enquiries have grown noticeably. The collaboration was effortless from first draft to launch.",
                    author: "Auto Global Group",
                    role: "Car dealership · Bratislava",
                },
                {
                    quote: "The design captured our diner's atmosphere perfectly. A retro style that works fast and modern on the web.",
                    author: "Elephant DINER",
                    role: "Restaurant · Rača",
                },
                {
                    quote: "A multilingual website delivered without complications. Candidates and clients find their way instantly.",
                    author: "Lunulus",
                    role: "Recruitment agency",
                },
            ],
        },
        faq: {
            overline: "FAQ",
            title: "Frequently asked questions",
            items: [
                {
                    q: "How much does a website cost?",
                    a: "Every quote is on request. No two projects are alike — we prepare a tailored quote within 48 hours based on scope, features and ambition. The initial consultation is free.",
                },
                {
                    q: "How long does a website take?",
                    a: "A simple site usually takes 2–3 weeks, larger projects 4–8 weeks. You receive an exact timeline together with the quote.",
                },
                {
                    q: "Do I need to prepare anything upfront?",
                    a: "No. An idea of your business is enough — structure, copy and design are prepared together during the initial consultation.",
                },
                {
                    q: "Can you improve my existing website?",
                    a: "Yes. We do complete redesigns as well as smaller improvements — visuals, speed and content alike.",
                },
                {
                    q: "Do you look after the site after launch?",
                    a: "Yes. We offer maintenance, updates and technical support so your website runs reliably long-term.",
                },
                {
                    q: "Which languages can you build in?",
                    a: "Slovak, English or fully multilingual — exactly matching where your customers are.",
                },
            ],
        },
        footer: {
            tagline: "Bespoke websites from Slovakia.",
            rights: "Webryno Studio. All rights reserved.",
        },
        blog: {
            overline: "Blog",
            title: "Notes from Webryno Studio",
            sub: "Practical insights on web design, pricing and how to turn a website into real clients.",
            metaTitleList: "Blog — Webryno Studio",
            metaDescription: "Practical articles on web design by Webryno Studio: website pricing, templates vs. bespoke design and how to turn a website into enquiries.",
            readMore: "Read article",
            allArticles: "All articles",
            back: "Back to blog",
            minRead: "min read",
            ctaTitle: "Want a website that brings clients?",
            ctaText: "The initial consultation is free and without obligation. We prepare a tailored quote within 48 hours.",
            ctaButton: "Request a quote",
        },
    },
};
